'use client';

import { Icon } from '@/app_components/common/Icon';
import { Tooltip } from '@/app_components/ui/Tooltip';

interface InfoIconProps {
  tooltip: string;
}

export const InfoIcon = ({ tooltip }: InfoIconProps) => {
  const trigger = (
    <Icon
      className='text-accent'
      icon='Info'
      size='sm'
    />
  );

  return <Tooltip content={tooltip}>{trigger}</Tooltip>;
};
